<app-new-banner [hideBackButton]="hideBackButton"></app-new-banner>
<new-flowbanner [enableHeader]="false" [showPromo]="true"></new-flowbanner>
<app-newstepper *ngIf='!isLoading' [activeStep]="2"></app-newstepper>

<app-loader *ngIf='isLoading'></app-loader>
<div div class="container" *ngIf="!isLoading && loaded">
    <app-help-to-call></app-help-to-call> 
    
    <div class="row justify-content-center align-items-center min-vh-100">
        
        <div class="col-md-7 p-lg-0">
            <div class="mb-4">
                <label class="custom-label">
                    Ahora completa los datos <br class="d-lg-none"> del propietario
                </label>
            </div>
            <div class="mb-4">
                <img
                    src="./assets/img/Apartamento.png"
                    alt="Imagen"
                    class="img-fluid d-none d-md-block"
                />
            </div>
        </div>

        <div class="global-form text-left col-sm-12 col-md-5 col-lg-5 offset-lg-0 p-0">
            <form [formGroup]="myForm" >
                <generalinput
                    [form]="myForm"
                    controlName="FirstName"
                    [isAlphaOnly]="true"
                    label="*Nombres"
                    alertMessage="Asegúrate de llenar este campo"
                    placeholder="Escribe tu primer nombre">
                </generalinput>
                <generalinput
                    [form]="myForm"
                    controlName="LastName"
                    [isAlphaOnly]="true"
                    label="*Apellidos"
                    alertMessage="Asegúrate de llenar este campo"
                    placeholder="Escribe tu primer apellido">
                </generalinput>
                <general-select
                    [form]="myForm"
                    controlName="DocumentType"
                    label="Tipo de Identificación"
                    [isReFill]="true">
                </general-select>
                <generalinput
                    [form]="myForm"
                    controlName="DocumentNumber"
                    [isNumberOnly]="true"
                    label="*Número de documento"
                    alertMessage="Asegúrate de llenar este campo"
                    placeholder="Digita el número sin puntos">
                </generalinput>
                <generaldate
                    [form]="myForm"
                    controlName="ExpeditionDate"
                    label="*Fecha expedición documento"
                    alertMessage="Asegúrate de llenar este campo"
                    [maxDate]="today"
                    placeholder="Selecciona la fecha"
                    [isReadOnly]="false"
                    [allowFutureDates]="false">
                </generaldate>
                <generalinput
                    [form]="myForm"
                    controlName="MobilePhone"
                    [isNumberOnly]="true"
                    label="*Número de celular"
                    alertMessage="Asegúrate de ingresar un número válido de 10 dígitos"
                    placeholder="Ej: 3004263078">
                </generalinput>
                <generalinput
                    [form]="myForm"
                    controlName="Mail"
                    label="*Correo electrónico"
                    alertMessage="Asegúrate de llenar este campo"
                    placeholder="usuario@correo.com"
                    [isEmail]="true">
                </generalinput>
                <small class="custom-small-text d-none d-md-block">
                    *Los campos son obligatorios
                </small>
                <general-chebox
                    [form]="myForm"
                    controlName="PersonalDataAuthorization"
                    label="*Tipo de identificación"
                    [useAlternativeText]="true">
                </general-chebox>
                <button
                    type="submit"
                    class="btn btn-primary w-100 py-2"
                    [disabled]="myForm.invalid || isClicked"
                    (click)="submit()">
                    Continuar
                </button>
            </form>

            <div class="modal-container" *ngIf="isModalOpen">
                <div class="modal">
                    <span class="close-btn" (click)="closeModal()">
                        <img
                            class="cerrar-blanco"
                            src="./assets/img/close-white.png"
                            alt="Cerrar"
                        />
                    </span>
                    <div class="modal-content">
                        <img src="./assets/img/info.png" alt="Imagen" class="input-icon" />
                        <h2>¡Ups! Revisa tus datos</h2>
                        <p>
                            La cédula del propietario
                            <span class="text-p"> no puede ser la misma que la del inquilino</span>.
                            Para continuar, verifica los datos y asegúrate de que correspondan
                            a personas diferentes.
                        </p>
                        <button class="close btn btn-secondary" (click)="closeModal()">
                            Corregir datos
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
<app-footer-app></app-footer-app>